import React from 'react';
import InstallPrompt from './components/InstallPrompt';
import { AuthProvider } from './context/AuthContext';
import { NavigationProvider } from './context/NavigationContext';
import MainComponent from './components/MainComponent';


const App: React.FC = () => {
    return (
        <AuthProvider>
            <NavigationProvider>
                    <InstallPrompt />
                    <MainComponent />
            </NavigationProvider>
        </AuthProvider>
    );
};

export default App;